import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { CompanyCognismTokenQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const companyCognismTokenQuery = graphql(`
  query companyCognismToken {
    companyCognismToken {
      source
      lastFour
    }
  }
`);

export const COMPANY_COGNISM_TOKEN_QUERY_KEY: QueryKey = ["companyCognismToken"];

export function useCompanyCognismToken(
  options?: UseQueryOptions<CompanyCognismTokenQuery, unknown, CompanyCognismTokenQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    COMPANY_COGNISM_TOKEN_QUERY_KEY,
    companyCognismTokenQuery,
    [{}],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return { data: data?.companyCognismToken, ...rest };
}
